import { ReactComponent as SubscriptIcon } from 'assets/icons/subscript16.svg'
import { useSubscriptToggle } from 'common/Prose/Toolbar/hooks/useSubscriptToggle'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const SubscriptInlineFormatButton = observer(function SubscriptInlineFormatButton({
  view,
  callback,
}: {
  view: EditorView
  callback?: () => void
}) {
  const { active, disabled, handleClick } = useSubscriptToggle(view)

  return (
    <InlineFormatDropdownMenuItem
      key="subscript"
      onClick={() => {
        handleClick()
        callback?.()
      }}
      active={active}
      isDisabled={disabled}
      icon={<SubscriptIcon />}
      label="Subscript"
    />
  )
})
